import styled, { css } from 'styled-components';
import { mediaMixin, token } from '@zillow/constellation';

export const Container = styled.div`
  position: relative;
  margin: 0 -24px;
  padding-bottom: 8px;
  border-bottom: 1px solid ${token('colors.gray400')};

  ${mediaMixin(
    'md',
    css`
      margin: 0;
      padding: 0;
      border: none;
      min-width: 320px;
    `,
  )};
`;

export const CollapsibleWrapperContainer = styled.div`
  margin: 16px 0 8px 24px;
`;

export const ChevronContainer = styled.div`
  position: absolute;
  top: 0px;
  right: 8px;
  padding: 8px 16px;
`;

export const DoneContainer = styled.div`
  width: 100%;
  padding: 8px 12px;
  background: ${token('colors.brand')};
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  box-sizing: border-box;
`;
